import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TaxB2PComponent } from './tax-b2p.component';

export const taxB2PRoutes: Routes = [
  {
    path: 'taxB2P',
    component: TaxB2PComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(taxB2PRoutes)],
  exports: [RouterModule]
})
export class TaxB2PRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-b2p/tax-b2p-routing.module.ts